import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { memo } from "react";
export const RegenerateShareLinkButtons = /*#__PURE__*/ memo((param)=>{
    let { onRegenerate, onClose, isLoading } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex justify-end gap-3",
        children: [
            /*#__PURE__*/ _jsx(Button, {
                appearance: "ghost",
                color: "grey",
                size: "large",
                onClick: onClose,
                disabled: isLoading,
                children: "Cancel"
            }),
            /*#__PURE__*/ _jsx(Button, {
                appearance: "filled",
                isLoading: isLoading,
                color: "blue",
                size: "large",
                onClick: onRegenerate,
                children: "Confirm"
            })
        ]
    });
});
RegenerateShareLinkButtons.displayName = "RegenerateShareLinkButtons";
